<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

export default {

	page: {
		title: 'Новый язык коммуникаций',
		meta: [{ name: 'description', content: appConfig.description }],
	},

	components: { Layout, PageHeader },

	data() {
		return {
			title: 'Новый язык коммуникаций',
			items: [],
            language_uuid: '',
            name: '',
            code: ''
		}
	},

	computed: {
        bot_item(){
            return this.$store.getters['languages/GET_LANGUAGES_ITEM'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            return session.user ? session.user : null;
        },
	},

	async mounted() {
        this.language_uuid = this.$route.params.language_uuid ? this.$route.params.language_uuid : '';
        if(this.language_uuid !== ''){

            this.title = 'Редактирование языка коммуникаций';
            document.title = appConfig.title + ' - ' + 'Редактирование языка коммуникаций';

            let data_send = {
                'uuid' : this.language_uuid
            }

            await this.$store.dispatch('languages/FETCH_LANGUAGES_ITEM', data_send);

            this.name = this.bot_item.name ? this.bot_item.name : '';
            this.code = this.bot_item.code ? this.bot_item.code : '';
        }
	},

	methods: {

        async saveItem(){

            let data_send = {
                'name' : this.name,
                'code' : this.code
            };

            let result = '';

            if(this.language_uuid === ''){
                result = await this.$store.dispatch('languages/FETCH_LANGUAGES_CREATE', data_send);
            } else {
                data_send.uuid = this.language_uuid;
                result = await this.$store.dispatch('languages/FETCH_LANGUAGES_UPDATE', data_send);
            }

            if(result === false){
                alert('Возникла ошибка');
            } else {
                this.$router.push({ name: 'Languages'});
            }
        }
	},
}

</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
        <b-form
            class="form-horizontal"
            @submit.prevent="saveItem"
        >
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <b-form-group
                                        label="Название языка"
                                        label-for="name"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="name"
                                            placeholder="Укажите название"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Код"
                                        label-for="code"
                                    >
                                        <b-form-input
                                            id="code"
                                            v-model="code"
                                            placeholder="Укажите код языка"
                                        ></b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                    </div>
                    <hr style="margin-bottom: 0px !important; margin-top: 0px !important">
                    <div style="padding: 0.75rem">
                        <button type="submit" class="btn btn-primary">Сохранить</button>
                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card-->
            </div>
            <!-- end col -->
        </div>
        </b-form>
	</Layout>
</template>
